import { FunctionComponent, ReactElement } from "react";

import RadioCheckbox from "rivals/components/shared/Form/RadioCheckbox";
import { OwnProps } from "rivals/components/shared/Form/RadioCheckbox/types";

const Checkbox: FunctionComponent<OwnProps> = ({
  className = "",
  data = "",
  disabled = false,
  isChecked,
  label,
  labelClassName,
  name = "",
  onChange
}): ReactElement => {
  return (
    <RadioCheckbox
      className={className}
      data={data}
      disabled={disabled}
      isChecked={isChecked}
      label={label}
      labelClassName={labelClassName}
      name={name}
      onChange={onChange}
      type="checkbox"
    />
  );
};

export default Checkbox;
